import { Box, styled } from '@mui/material';

const darkBg = '#1F2023';
const lightBg = '#FFFFFF';
const borderDark = '#383B40';
const borderLight = '#C4C4C4';

export const CellWrap = styled(Box, {
    shouldForwardProp: (prop) =>
        prop !== 'colorScheme' && prop !== 'hideTopBorder' && prop !== 'hideBottomBorder',
})<{ colorScheme: string; hideTopBorder?: boolean; hideBottomBorder?: boolean }>(
    ({ colorScheme, hideTopBorder, hideBottomBorder }) => ({
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: '69px',
        flexGrow: 1,
        backgroundColor: colorScheme === 'dark' ? darkBg : lightBg,
        border: `0.5px solid ${colorScheme === 'dark' ? borderDark : borderLight}`,
        borderTop: hideTopBorder
            ? 'none'
            : `0.5px solid ${colorScheme === 'dark' ? borderDark : borderLight}`,
        borderBottom: hideBottomBorder
            ? 'none'
            : `0.5px solid ${colorScheme === 'dark' ? borderDark : borderLight}`,
    }),
);

export const EmptyCell = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'colorScheme',
})<{ colorScheme: string }>(({ colorScheme }) => ({
    cursor: 'pointer',
    display: 'flex',
    flexGrow: 1,
    backgroundColor: colorScheme === 'dark' ? darkBg : lightBg,
    '&:hover': {
        backgroundColor: '#3366FF',
    },
}));

export const BlockedCell = styled(Box)(() => ({
    display: 'flex',
    height: '100%',
    pointerEvents: 'none',
}));

export const BookedCell = styled(Box, {
    shouldForwardProp: (prop) =>
        prop !== 'colorScheme' && prop !== 'fillPercentage' && prop !== 'isContinuing',
})<{ colorScheme: string; fillPercentage: number; isContinuing?: boolean }>(
    ({ colorScheme, fillPercentage, isContinuing }) => ({
        display: 'flex',
        height: `${fillPercentage}%`,
        backgroundColor: colorScheme === 'dark' ? '#27292D' : '#D9D9D9',
        color: colorScheme === 'dark' ? '#FFFFFF' : '#000000',
        border: isContinuing
            ? 'none'
            : `0.5px solid ${colorScheme === 'dark' ? borderDark : borderLight}`,
        borderTop: isContinuing ? 'none' : undefined,
        borderBottom: isContinuing ? 'none' : undefined,
        padding: isContinuing ? '0' : '5px 0 0 3px',
        flexDirection: 'column',
    }),
);

export const BookingText = styled(Box)(() => ({
    fontWeight: 550,
    fontSize: '8px',
    lineHeight: '10px',
    marginRight: '5px',
}));
